const category = {
  textTransform: "uppercase",
  marginTop: 16,
  position: "relative",
};

export default { category };
